import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedPipesModule } from './shared-pipes.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BaseModalComponent } from './components/base-modal/base-modal.component';
import { BootstrapModule } from './shared-bootstrap.module';
import { SharedGlobalModule } from './shared-global.module';
import { SelectLessonComponent } from './components/select-lesson/select-lesson.component';
import { SelectClassroomComponent } from './components/select-classroom/select-classroom.component';
import { SelectClassLevelComponent } from './components/select-classlevel/select-classlevel.component';
import { SelectInstructorComponent } from './components/select-instructor/select-instructor.component';
import { SelectProvinceComponent } from './components/select-province/select-province.component';
import { SelectDistrictComponent } from './components/select-district/select-district.component';
import { SelectTermComponent } from './components/select-term/select-term.component';
import { SelectCourseStudentComponent } from './components/select-course-student/select-course-student.component';
import { SelectRoleComponent } from './components/select-role/select-role.component';
import { SelectMajorComponent } from './components/select-major/select-major.component';
import { UploadImageComponent } from './components/upload-image/upload-image.component';
import { TimepickerComponent } from './components/timepicker/timepicker.component';
import { SelectSubjectComponent } from './components/select-subject/select-subject.component';
import { SelectParentComponent } from './components/select-parent/select-parent.component';
import { SelectClassComponent } from './components/select-class/select-class.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { SelectAlanComponent } from './components/select-alan/select-alan.component';
import { SelectDayOfWeekComponent } from './components/select-dayofweek/select-dayofweek.component';
import { TableVirtualClassComponent } from './components/table-virtual-class/table-virtual-class.component';
import { CardVirtualClassComponent } from './components/card-virtual-class/card-virtual-class.component';
import { DataTablesModule } from 'angular-datatables';
import { EditVirtualClassComponent } from './components/table-virtual-class/edit-virtual-class/edit-virtual-class.component';
import { AddVirtualClassComponent } from './components/table-virtual-class/add-virtual-class/add-virtual-class.component';
import { TableAppointmentComponent } from './components/table-appointment/table-appointment.component';
import { AddAppointmentComponent } from './components/table-appointment/add-appointment/add-appointment.component';
import { EditAppointmentAdminComponent } from './components/table-appointment/edit-appointment-admin/edit-appointment-admin.component';
import { EditAppointmentInstructorComponent } from './components/table-appointment/edit-appointment-instructor/edit-appointment-instructor.component';
import { TableQuestionComponent } from './components/table-question/table-question.component';
import { AddQuestionComponent } from './components/table-question/add-question/add-question.component';
import { TableQuestionMessageComponent } from './components/table-question-message/table-question-message.component';
import { EditQuestionComponent } from './components/table-question/edit-question/edit-question.component';
import { TimeTableComponent } from './components/time-table/time-table.component';
import { AddTimeTableComponent } from './components/time-table/add-time-table/add-time-table.component';
import { EditTimeTableComponent } from './components/time-table/edit-time-table/edit-time-table.component';
import { AddMessageComponent } from './components/table-question-message/add-message/add-message.component';
import { AnnouncementMasterComponent } from './components/announcement-master/announcement-master.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { AnnouncementTenantComponent } from './components/announcement-tenant/announcement-tenant.component';
import { TableClassDocumentComponent } from './components/table-class-document/table-class-document.component';
import { AddClassDocumentComponent } from './components/table-class-document/add-class-document/add-class-document.component';
import { InputFileComponent } from './components/input-file/input-file.component';
import { SelectMyFilesComponent } from './components/select-myfiles/select-myfiles.component';
import { AddAppointmentAdminComponent } from './components/table-appointment/add-appointment-admin/add-appointment-admin.component';
import { SelectStudentComponent } from './components/select-student/select-student.component';
import { CropImageComponent } from './components/crop-image/crop-image.component';
import { AddVirtualClassInstructorComponent } from './components/table-virtual-class/add-virtual-class-instructor/add-virtual-class-instructor.component';
import { DateSelectComponent } from './components/date-select/date-select.component';
import { ParticipantStudentlistComponent } from './components/participant-studentlist/participant-studentlist.component';
import { TableNoteComponent } from './components/table-note/table-note.component';
import { AllannouncementComponent } from './components/allannouncement/allannouncement.component';
import { TableExpenseComponent } from './components/table-expense/table-expense.component';
import { EditExpenseComponent } from './components/table-expense/edit-expense/edit-expense.component';
import { AddExpenseComponent } from './components/table-expense/add-expense/add-expense.component';
import { SelectSafeBoxComponent } from './components/select-safebox/select-safebox.component';
import { SelectCategoryComponent } from './components/select-category/select-category.component';
import { SelectFinanceCategoryComponent } from './components/select-finance-category/select-finance-category.component';
import { VimeModule } from '@vime/angular';
import { NgxCurrencyModule } from 'ngx-currency';
import { InputCurrencyComponent } from './components/input-currency/input-currency.component';
import { TableInvoiceComponent } from './components/table-invoice/table-invoice.component';
import { AddInvoiceComponent } from './components/table-invoice/add-invoice/add-invoice.component';
import { EditInvoiceComponent } from './components/table-invoice/edit-invoice/edit-invoice.component';
import { ExamSubjectsComponent } from './components/exam-subjects/exam-subjects.component';
import { SelectSubjectTypeaheadComponent } from './components/select-subject-typeahead/select-subject-typeahead.component';
import { AddSubjectComponent } from './components/add-subject/add-subject.component';
import { TableInstallmentComponent } from './components/table-Installment/table-Installment.component';
import { AddInstallmentPaymentComponent } from './components/table-Installment/add-InstallmentPayment/add-InstallmentPayment.component';
import { EditInstallmentPaymentComponent } from './components/table-Installment/edit-InstallmentPayment/edit-InstallmentPayment.component';
import { SelectInvoiceComponent } from './components/select-invoice/select-invoice.component';
import { AddExpenseCompanyComponent } from './components/table-expense/add-expense-company/add-expense-company.component';
import { SelectCompanyComponent } from './components/select-company/select-company.component';
import { ChangeProfilePhotoComponent } from './components/change-profile-photo/change-profile-photo.component';
import { TableConnectionComponent } from './components/table-connection/table-connection.component';
import { AddConnectionComponent } from './components/table-connection/add-connection/add-connection.component';
import { EditConnectionComponent } from './components/table-connection/edit-connection/edit-connection.component';
import { TableActivityComponent } from './components/table-activity/table-activity.component';
import { AddActivityComponent } from './components/table-activity/add-activity/add-activity.component';
import { EditActivityComponent } from './components/table-activity/edit-activity/edit-activity.component';
import { SelectActivityCategoryComponent } from './components/select-activity-category/select-activity-category.component';
import { EditParticipantComponent } from './components/table-participant/edit-participant/edit-participant.component';
import { TableParticipantComponent } from './components/table-participant/table-participant.component';
import { AddParticipantComponent } from './components/table-participant/add-participant/add-participant.component';
import { SurveyTestComponent } from './components/survey-test/survey-test.component';
import { TableTrainingComponent } from './components/table-training/table-training.component';
import { AddTrainingComponent } from './components/table-training/add-training/add-training.component';
import { EditTrainingComponent } from './components/table-training/edit-training/edit-training.component';
import { SurveyTestResultComponent } from './components/survey-test-result/survey-test-result.component';
import { AddDocumentTemplateComponent } from './components/table-document-template/add-document-template/add-document-template.component';
import { TableTrainingSurveyComponent } from './components/table-training-survey/table-training-survey.component';
import { EditGroupComponent } from './components/table-group/edit-group/edit-group.component';
import { AddGroupComponent } from './components/table-group/add-group/add-group.component';
import { TableGroupComponent } from './components/table-group/table-group.component';
import { TableDocumentTemplateComponent } from './components/table-document-template/table-document-template.component';
import { SelectParticipantComponent } from './components/select-participant/select-participant.component';
import { SelectTestComponent } from './components/select-test/select-test.component';
import { TableDocumentTrainingComponent } from './components/table-document-training/table-document-training.component';
import { AddDocumentTrainingComponent } from './components/table-document-training/add-document-training/add-document-training.component';
import { AddTrainingTestComponent } from './components/table-document-training/add-training-test/add-training-test.component';
import { SurveyVakaComponent } from './components/survey-vaka/survey-vaka.component';
import { AddTrainingVakaComponent } from './components/table-document-training/add-training-vaka/add-training-vaka.component';
import { SelectVakaComponent } from './components/select-vaka/select-vaka.component';
import { SelectTrainingComponent } from './components/select-training/select-training.component';
import { EditClassDocumentVakaComponent } from './components/table-class-document/edit-class-document-vaka/edit-class-document-vaka.component';
import { SurveyVakaResultComponent } from './components/survey-vaka-result/survey-vaka-result.component';
import { TableTestComponent } from './components/table-test/table-test.component';
import { CardTrainingGroupComponent } from './components/card-training-group/card-training-group.component';
import { TableCustomerComponent } from './components/table-customer/table-customer.component';
import { EditCustomerComponent } from './components/table-customer/edit-customer/edit-customer.component';
import { AddCustomerComponent } from './components/table-customer/add-customer/add-customer.component';
import { TableDocumentStudentComponent } from './components/table-document-student/table-document-student.component';
import { AddDocumentStudentComponent } from './components/table-document-student/add-document-student/add-document-student.component';
import { AddStudentVakaComponent } from './components/table-document-student/add-student-vaka/add-student-vaka.component';
import { AddStudentTestComponent } from './components/table-document-student/add-student-test/add-student-test.component';
import { TableReportComponent } from './components/table-report/table-report.component';
import { SearchStudentReportComponent } from './components/table-report/search-student-report/search-student-report.component';
import { SearchClassReportComponent } from './components/table-report/search-class-report/search-class-report.component';
import { SharedReportModule } from './shared-report.module';
import { TableReportStudentComponent } from './components/table-report-student/table-report-student.component';
import { TableReportClassComponent } from './components/table-report-class/table-report-class.component';
import { SharedModalModule } from './shared-modal.module';
import { TableGroupRoleComponent } from './components/table-group-role/table-group-role.component';
import { EditDocumentComponent } from './components/table-document-student/edit-document/edit-document.component';
import { SelectMaterialComponent } from './components/select-material/select-material.component';
import { VirtualComponent } from './components/virtual/virtual.component';
import { TableActivityCategoryComponent } from './components/table-activity-category/table-activity-category.component';
import { EditActivityCategoryComponent } from './components/table-activity-category/edit-activity-category/edit-activity-category.component';
import { AddActivityCategoryComponent } from './components/table-activity-category/add-activity-category/add-activity-category.component';
import { TableSubclassComponent } from './components/table-subclass/table-subclass.component';
import { AddSubclassComponent } from './components/table-subclass/add-subclass/add-subclass.component';
import { SendMailGroupComponent } from './components/table-group/send-mail-group/send-mail-group.component';
import { TableDocumentGroupTemplateComponent } from './components/table-document-group-template/table-document-group-template.component';
import { AddDocumentGroupTemplateComponent } from './components/table-document-group-template/add-document-group-template/add-document-group-template.component';
import { EditDocumentGroupTemplateComponent } from './components/table-document-group-template/edit-document-group-template/edit-document-group-template.component';
import { AddAssessmentTestComponent } from './components/table-document-group-template/add-assessment-test/add-assessment-test.component';
import { AddAssessmentVakaComponent } from './components/table-document-group-template/add-assessment-vaka/add-assessment-vaka.component';
import { DetailDocumentGroupTemplateComponent } from './components/table-document-group-template/detail-document-group-template/detail-document-group-template.component';
import { TableDocumentAssessmentClassComponent } from './components/table-document-assessment-class/table-document-assessment-class.component';
import { EditDocumentAssessmentClassComponent } from './components/table-document-assessment-class/edit-document-assessment-class/edit-document-assessment-class.component';
import { SelectAssessmentTemplateComponent } from './components/select-assessment-template/select-assessment-template';
import { ShareDocumentAssessmentStudentComponent } from './components/table-document-assessment-class/share-document-assessment-student/share-document-assessment-student.component';
import { SendMailParticipantComponent } from './components/table-participant/send-mail-participant/send-mail-participant.component';
import { TrainingPrintComponent } from './report-print/training-print/training-print.component';
import { ReportPrintAssesmentComponent } from './report-print/report-print-assesment/report-print-assesment.component';
import { TrainingClassPrintComponent } from './report-print/training-class-print/training-class-print.component';
import { SearchTrainingReportComponent } from './components/table-report/search-training-report/search-training-report.component';
import { TableReportTrainingComponent } from './components/table-report-training/table-report-training.component';

@NgModule({
  declarations: [
    SelectLessonComponent,
    SelectClassroomComponent,
    SelectClassLevelComponent,
    SelectInstructorComponent,
    SelectProvinceComponent,
    SelectDistrictComponent,
    SelectTermComponent,
    SelectCourseStudentComponent,
    SelectRoleComponent,
    SelectMajorComponent,
    SelectSubjectComponent,
    SelectClassComponent,
    SelectParentComponent,
    SelectAlanComponent,
    SelectStudentComponent,
    UploadImageComponent,
    TimepickerComponent,
    ChangePasswordComponent,
    SelectDayOfWeekComponent,
    TableVirtualClassComponent,
    AddVirtualClassComponent,
    EditVirtualClassComponent,
    AddVirtualClassInstructorComponent,
    TableAppointmentComponent,
    AddAppointmentComponent,
    AddAppointmentAdminComponent,
    EditAppointmentAdminComponent,
    EditAppointmentInstructorComponent,
    TableQuestionComponent,
    AddQuestionComponent,
    EditQuestionComponent,
    TableQuestionMessageComponent,
    CardVirtualClassComponent,
    TimeTableComponent,
    AddTimeTableComponent,
    EditTimeTableComponent,
    AddMessageComponent,
    AnnouncementMasterComponent,
    AnnouncementTenantComponent,
    TableClassDocumentComponent,
    AddClassDocumentComponent,
    InputFileComponent,
    SelectMyFilesComponent,
    CropImageComponent,
    DateSelectComponent,
    ParticipantStudentlistComponent,
    TableNoteComponent,
    AllannouncementComponent,
    TableExpenseComponent,
    AddExpenseComponent,
    AddExpenseCompanyComponent,
    EditExpenseComponent,
    SelectSafeBoxComponent,
    SelectCategoryComponent,
    SelectFinanceCategoryComponent,
    InputCurrencyComponent,
    TableInvoiceComponent,
    AddInvoiceComponent,
    EditInvoiceComponent,
    TableInstallmentComponent,
    AddInstallmentPaymentComponent,
    EditInstallmentPaymentComponent,
    ExamSubjectsComponent,
    SelectSubjectTypeaheadComponent,
    AddSubjectComponent,
    SelectInvoiceComponent,
    SelectCompanyComponent,
    ChangeProfilePhotoComponent,
    TableConnectionComponent,
    AddConnectionComponent,
    EditConnectionComponent,
    TableActivityComponent,
    AddActivityComponent,
    EditActivityComponent,
    SelectActivityCategoryComponent,
    TableParticipantComponent,
    AddParticipantComponent,
    EditParticipantComponent,
    SurveyTestComponent,
    TableTrainingComponent,
    AddTrainingComponent,
    EditTrainingComponent,
    SurveyTestResultComponent,
    SurveyVakaResultComponent,
    AddDocumentTemplateComponent,
    TableTrainingSurveyComponent,
    TableDocumentTemplateComponent,
    SelectTestComponent,
    TableGroupComponent,
    AddGroupComponent,
    EditGroupComponent,
    TableDocumentTemplateComponent,
    SelectParticipantComponent,
    TableDocumentTrainingComponent,
    AddDocumentTrainingComponent,
    AddTrainingTestComponent,
    SurveyVakaComponent,
    AddTrainingVakaComponent,
    SelectVakaComponent,
    SelectTrainingComponent,
    EditClassDocumentVakaComponent,
    TableTestComponent,
    CardTrainingGroupComponent,
    TableCustomerComponent,
    AddCustomerComponent,
    EditCustomerComponent,
    TableDocumentStudentComponent,
    AddDocumentStudentComponent,
    AddStudentTestComponent,
    AddStudentVakaComponent,
    TableReportComponent,
    SearchStudentReportComponent,
    SearchClassReportComponent,
    SearchTrainingReportComponent,
    TableReportStudentComponent,
    TableReportClassComponent,
    TableGroupRoleComponent,
    EditDocumentComponent,
    SelectMaterialComponent,
    VirtualComponent,
    AddActivityCategoryComponent,
    EditActivityCategoryComponent,
    TableActivityCategoryComponent,
    TableSubclassComponent,
    AddSubclassComponent,
    SendMailGroupComponent,
    TableDocumentGroupTemplateComponent,
    AddDocumentGroupTemplateComponent,
    EditDocumentGroupTemplateComponent,
    AddAssessmentTestComponent,
    AddAssessmentVakaComponent,
    DetailDocumentGroupTemplateComponent,
    TableDocumentAssessmentClassComponent,
    EditDocumentAssessmentClassComponent,
    SelectAssessmentTemplateComponent,
    ShareDocumentAssessmentStudentComponent,
    SendMailParticipantComponent,
    TrainingPrintComponent,
    ReportPrintAssesmentComponent,
    TrainingClassPrintComponent,
    TableReportTrainingComponent
  ],
  imports: [
    CommonModule,
    SharedPipesModule,
    RouterModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    BootstrapModule,
    SharedGlobalModule,
    DataTablesModule,
    SwiperModule,
    VimeModule,
    NgxCurrencyModule,
    SharedReportModule,
    SharedModalModule
  ],
  exports: [
    SelectLessonComponent,
    SelectClassroomComponent,
    SelectClassLevelComponent,
    SelectInstructorComponent,
    SelectProvinceComponent,
    SelectDistrictComponent,
    SelectTermComponent,
    SelectCourseStudentComponent,
    SelectRoleComponent,
    SelectMajorComponent,
    SelectSubjectComponent,
    SelectClassComponent,
    SelectParentComponent,
    SelectAlanComponent,
    SelectStudentComponent,
    UploadImageComponent,
    TimepickerComponent,
    ChangePasswordComponent,
    SelectDayOfWeekComponent,
    TableVirtualClassComponent,
    TableAppointmentComponent,
    AddAppointmentComponent,
    EditAppointmentAdminComponent,
    EditAppointmentInstructorComponent,
    TableQuestionComponent,
    TableQuestionMessageComponent,
    CardVirtualClassComponent,
    TimeTableComponent,
    AddMessageComponent,
    AnnouncementMasterComponent,
    AnnouncementTenantComponent,
    TableClassDocumentComponent,
    InputFileComponent,
    SelectMyFilesComponent,
    CropImageComponent,
    DateSelectComponent,
    ParticipantStudentlistComponent,
    TableNoteComponent,
    AllannouncementComponent,
    TableExpenseComponent,
    AddExpenseComponent,
    AddExpenseCompanyComponent,
    EditExpenseComponent,
    NgxCurrencyModule,
    SelectSafeBoxComponent,
    SelectCategoryComponent,
    SelectFinanceCategoryComponent,
    InputCurrencyComponent,
    TableInvoiceComponent,
    AddInvoiceComponent,
    EditInvoiceComponent,
    TableInstallmentComponent,
    AddInstallmentPaymentComponent,
    EditInstallmentPaymentComponent,
    ExamSubjectsComponent,
    SelectSubjectTypeaheadComponent,
    AddSubjectComponent,
    SelectInvoiceComponent,
    SelectCompanyComponent,
    ChangeProfilePhotoComponent,
    TableConnectionComponent,
    AddConnectionComponent,
    EditConnectionComponent,
    TableActivityComponent,
    AddActivityComponent,
    EditActivityComponent,
    SelectActivityCategoryComponent,
    TableParticipantComponent,
    AddParticipantComponent,
    EditParticipantComponent,
    SurveyTestComponent,
    TableTrainingComponent,
    AddTrainingComponent,
    EditTrainingComponent,
    SurveyTestResultComponent,
    SurveyVakaResultComponent,
    AddDocumentTemplateComponent,
    TableTrainingSurveyComponent,
    TableDocumentTemplateComponent,
    SelectTestComponent,
    TableGroupComponent,
    AddGroupComponent,
    EditGroupComponent,
    TableDocumentTemplateComponent,
    SelectParticipantComponent,
    TableDocumentTrainingComponent,
    AddDocumentTrainingComponent,
    AddTrainingTestComponent,
    SurveyVakaComponent,
    AddTrainingVakaComponent,
    SelectVakaComponent,
    SelectTrainingComponent,
    EditClassDocumentVakaComponent,
    TableTestComponent,
    CardTrainingGroupComponent,
    TableCustomerComponent,
    AddCustomerComponent,
    EditCustomerComponent,
    TableDocumentStudentComponent,
    AddDocumentStudentComponent,
    AddStudentTestComponent,
    AddStudentVakaComponent,
    TableReportComponent,
    SearchStudentReportComponent,
    SearchClassReportComponent,
    SearchTrainingReportComponent,
    TableReportStudentComponent,
    TableReportClassComponent,
    AddVirtualClassInstructorComponent,
    TableGroupRoleComponent,
    EditDocumentComponent,
    SelectMaterialComponent,
    VirtualComponent,
    AddActivityCategoryComponent,
    EditActivityCategoryComponent,
    TableActivityCategoryComponent,
    TableSubclassComponent,
    AddSubclassComponent,
    SendMailGroupComponent,
    TableDocumentGroupTemplateComponent,
    AddDocumentGroupTemplateComponent,
    EditDocumentGroupTemplateComponent,
    AddAssessmentTestComponent,
    AddAssessmentVakaComponent,
    DetailDocumentGroupTemplateComponent,
    TableDocumentAssessmentClassComponent,
    EditDocumentAssessmentClassComponent,
    SelectAssessmentTemplateComponent,
    ShareDocumentAssessmentStudentComponent,
    SendMailParticipantComponent,
    TrainingPrintComponent,
    ReportPrintAssesmentComponent,
    TrainingClassPrintComponent,
    TableReportTrainingComponent
  ]
})
export class SharedComponentsModule { }
